import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "b-profile-calendar--list" }
const _hoisted_2 = { class: "h-flex h-flex-space-between" }
const _hoisted_3 = { class: "b-profile-calendar-page__inner h-pos-rel" }
const _hoisted_4 = { class: "text-left h-capitalize" }
const _hoisted_5 = {
  key: 0,
  class: "h-pos-rel"
}
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "h-font-14 h-fw-700 h-opacity-0_5 h-mb-20" }
const _hoisted_8 = { class: "h-flex h-flex-wrap h-flex-space-between h-mt-30" }
const _hoisted_9 = { style: {"width":"355px","margin-bottom":"20px"} }
const _hoisted_10 = { class: "h-font-14 h-fw-700 h-opacity-0_5 h-mb-20" }
const _hoisted_11 = { class: "h-flex h-flex-wrap h-flex-dir-column h-flex-space-between h-mt-30 qa-profile-calendar-synced-item" }
const _hoisted_12 = { style: {"width":"355px","margin-bottom":"20px"} }
const _hoisted_13 = { class: "h-fw-500 b-text-error qa-profile-calendar-synced-item-error" }
const _hoisted_14 = {
  key: 0,
  class: "h-font-14 h-fw-700 h-opacity-0_5"
}
const _hoisted_15 = { class: "h-flex h-flex-wrap h-flex-space-between h-mt-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwCheckbox = _resolveComponent("FwCheckbox")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwImage = _resolveComponent("FwImage")!
  const _component_InformationPopup = _resolveComponent("InformationPopup")!
  const _component_DeSyncCalendarPopup = _resolveComponent("DeSyncCalendarPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(`${_ctx.platform} Calendar`), 1),
        (!_ctx.isCalendarExist)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('CALENDAR-SYNC.POPUP.SYNC.TEXT')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.syncCalendar)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('CALENDAR-SYNC.SYNCHRONIZED')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FwCheckbox, {
                id: _ctx.syncCalendar.id,
                modelValue: _ctx.calendarToSync,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.calendarToSync) = $event)),
                value: _ctx.syncCalendar,
                class: "icon-white__background",
                type: "white-with-text-round",
                text: _ctx.syncCalendar.name,
                singleSelect: "",
                name: "checkbox",
                onShowDeletePopup: _ctx.showDeletePopup
              }, _createSlots({ _: 2 }, [
                (_ctx.isCalendarSynchronized)
                  ? {
                      name: "deleteBtn",
                      fn: _withCtx(() => [
                        _createVNode(_component_FwIcon, {
                          class: "h-mt-2",
                          icon: "close",
                          size: "11",
                          color: "#fff"
                        })
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["id", "modelValue", "value", "text", "onShowDeletePopup"])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.syncCalendarFailed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('CALENDAR-SYNC.ERROR')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FwCheckbox, {
                id: _ctx.syncCalendarFailed.id,
                modelValue: _ctx.calendarToSync,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.calendarToSync) = $event)),
                value: _ctx.syncCalendarFailed,
                class: "icon-white__background",
                type: "white-with-text-round",
                text: _ctx.syncCalendarFailed.name,
                singleSelect: "",
                name: "checkbox",
                onShowDeletePopup: _ctx.showDeletePopup
              }, _createSlots({ _: 2 }, [
                (_ctx.isCalendarSynchronizedWithError)
                  ? {
                      name: "deleteBtn",
                      fn: _withCtx(() => [
                        _createVNode(_component_FwIcon, {
                          class: "h-mt-2",
                          icon: "close",
                          size: "11",
                          color: "#fff"
                        })
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["id", "modelValue", "value", "text", "onShowDeletePopup"])
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('ERRORS.OCCURED.SYNCHRONIZATION')) + ": " + _toDisplayString(_ctx.errorCalendarReasonMessage), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.otherCalendars.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.syncCalendar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('CALENDAR-SYNC.NON.SYNCHRONIZED.OTHER')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherCalendars, (item, id) => {
              return (_openBlock(), _createElementBlock("div", {
                key: id,
                style: {"width":"355px","margin-bottom":"20px"}
              }, [
                _createVNode(_component_FwCheckbox, {
                  id: id,
                  modelValue: _ctx.calendarToSync,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calendarToSync) = $event)),
                  value: item,
                  class: "icon-white__background",
                  type: "white-with-text-round",
                  text: item.name,
                  singleSelect: "",
                  name: "checkbox",
                  onChange: _cache[3] || (_cache[3] = value => _ctx.calendarToSync = value)
                }, null, 8, ["id", "modelValue", "value", "text"])
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.isCalendarExist)
      ? (_openBlock(), _createBlock(_component_FwButton, {
          key: 3,
          class: "h-mt-30",
          borderRadiusType: "tiny-border",
          iconLeft: "circle-arrows",
          disabled: !_ctx.calendarToSync.length || _ctx.isCalendarSynchronized || _ctx.isCalendarSynchronizedWithError,
          onClick: _ctx.sendCalendarToSync
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CALENDAR-SYNC.POPUP.SYNC.TITLE')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.isCalendarSyncStart)
      ? (_openBlock(), _createBlock(_component_InformationPopup, {
          key: 4,
          maxWidth: "500px",
          headerText: _ctx.$t(`CALENDAR-SYNC.POPUP.SYNC.TEXT.IN.PROGRESS`),
          bodyText: _ctx.$t(`CALENDAR-SYNC.POPUP.SYNC.TEXT.FEW.MINUTES`),
          buttonText: _ctx.$t(`CALENDAR-SYNC.POPUP.SYNC.TEXT.GO.CALENDAR`),
          onClose: _ctx.getStatus,
          onGoToPage: _ctx.routeToCalendar
        }, {
          imageHeader: _withCtx(() => [
            _createVNode(_component_FwImage, {
              class: "h-mb-30",
              src: _ctx.requireImage("google-sync-icon.svg")
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["headerText", "bodyText", "buttonText", "onClose", "onGoToPage"]))
      : _createCommentVNode("", true),
    (_ctx.isPopupDeleteShown)
      ? (_openBlock(), _createBlock(_component_DeSyncCalendarPopup, {
          key: 5,
          instance: _ctx.calendarToDeSync,
          isRequestSending: _ctx.isDeleteRequestSending,
          onDeSyncCalendar: _ctx.deSyncCalendar,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isPopupDeleteShown = false))
        }, null, 8, ["instance", "isRequestSending", "onDeSyncCalendar"]))
      : _createCommentVNode("", true)
  ]))
}